import { render, staticRenderFns } from "./profile-information.vue?vue&type=template&id=fb24697e&scoped=true&"
import script from "./profile-information.vue?vue&type=script&lang=js&"
export * from "./profile-information.vue?vue&type=script&lang=js&"
import style0 from "./profile-information.vue?vue&type=style&index=0&id=fb24697e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb24697e",
  null
  
)

export default component.exports